<template>
  <div style="position: relative">
    <div ref="pyramide_chart" style="height: 290px"></div>
    <div style="position: absolute; bottom: 20px; left: 100px; right: 40px; font-weight: bold">
      <div style="display: flex; justify-content: space-between">
        <div style="color: #66b7dc;">
          Homme
        </div>
        <div style="color: #6794dc;">
          Femme
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import An from "@/components/AnimateNumber.vue";

export default {
  components: { An },
  props: {
    graph_data: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    event_name: {
      type: String,
      required: false,
      default: "updateData_pyramide",
    },
  },
  watch: {
    timestamp() {
      if (this.evt == null) {
        this.evt = new CustomEvent(this.event_name);
      }
      this.$refs.pyramide_chart.dispatchEvent(this.evt);
    },
  },
  data() {
    return {
      evt: null,
      chart_data: [
        {
          age: "0_17",
          male: 0,
          female: 0,
        },
        {
          age: "18_24",
          male: 0,
          female: 0,
        },
        {
          age: "25_29",
          male: 0,
          female: 0,
        },
        {
          age: "30_34",
          male: 0,
          female: 0,
        },
        {
          age: "35_39",
          male: 0,
          female: 0,
        },
        {
          age: "40_44",
          male: 0,
          female: 0,
        },
        {
          age: "45_49",
          male: 0,
          female: 0,
        },
        {
          age: "50_54",
          male: 0,
          female: 0,
        },
        {
          age: "55_59",
          male: 0,
          female: 0,
        },
        {
          age: "60_64",
          male: 0,
          female: 0,
        },
        {
          age: "65_plus",
          male: 0,
          female: 0,
        },
      ],
    };
  },
  methods: {
    createGraph() {
      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);
      am4core.options.autoDispose = true;

      var chart = am4core.create(this.$refs.pyramide_chart, am4charts.XYChart);

      this.chart_data.map((a) => {
        a.female = this.graph_data.f[a.age];
        a.male = -this.graph_data.h[a.age];
      });

      this.$refs.pyramide_chart.addEventListener(
        this.event_name,
        () => {
          chart.data.map((a) => {
            a.female = this.graph_data.f[a.age];
            a.male = -this.graph_data.h[a.age];
          });

          chart.invalidateRawData();
        },
        false
      );

      // Add data
      chart.data = this.chart_data;

      // Use only absolute numbers
      chart.numberFormatter.numberFormat = "#.#s";

      // Create axes
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "age";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.inversed = false;
      categoryAxis.renderer.minGridDistance = 0;

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.extraMin = 0.1;
      valueAxis.extraMax = 0.1;
      valueAxis.renderer.minGridDistance = 40;
      // valueAxis.renderer.ticks.template.length = 5;
      valueAxis.renderer.ticks.template.disabled = true;
      // valueAxis.renderer.ticks.template.strokeOpacity = 1;
      valueAxis.renderer.labels.template.adapter.add("text", function (text) {
        return "";
        return text == "Male" || text == "Female" ? text : text + "%";
      });

      // Create series
      var male = chart.series.push(new am4charts.ColumnSeries());
      male.dataFields.valueX = "male";
      male.dataFields.categoryY = "age";
      male.clustered = false;

      var maleLabel = male.bullets.push(new am4charts.LabelBullet());
      maleLabel.label.text = "{valueX}%";
      maleLabel.label.hideOversized = false;
      maleLabel.label.truncate = false;
      maleLabel.label.horizontalCenter = "right";
      maleLabel.label.dx = -10;

      var female = chart.series.push(new am4charts.ColumnSeries());
      female.dataFields.valueX = "female";
      female.dataFields.categoryY = "age";
      female.clustered = false;

      var femaleLabel = female.bullets.push(new am4charts.LabelBullet());
      femaleLabel.label.text = "{valueX}%";
      femaleLabel.label.hideOversized = false;
      femaleLabel.label.truncate = false;
      femaleLabel.label.horizontalCenter = "left";
      femaleLabel.label.dx = 10;

      // var maleRange = valueAxis.axisRanges.create();
      // maleRange.value = -10;
      // maleRange.endValue = 0;
      // maleRange.label.text = "Homme";
      // maleRange.label.fill = chart.colors.list[0];
      // maleRange.label.dy = 20;
      // maleRange.label.fontWeight = "600";
      // maleRange.grid.strokeOpacity = 0;
      // maleRange.grid.stroke = male.stroke;

      // var femaleRange = valueAxis.axisRanges.create();
      // femaleRange.value = 0;
      // femaleRange.endValue = 10;
      // femaleRange.label.text = "Femme";
      // femaleRange.label.fill = chart.colors.list[1];
      // femaleRange.label.dy = 20;
      // femaleRange.label.fontWeight = "600";
      // femaleRange.grid.strokeOpacity = 0;
      // femaleRange.grid.stroke = female.stroke;
    },
  },
  mounted() {
    setTimeout(() => {
      this.createGraph();
    }, 100);
  },
};
</script>
